import React from 'react';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-[100vh] w-full overflow-hidden bg-[#0f0d0b]">
      {/* Background image */}
      <div
        className="hero-bg absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.wixstatic.com/media/bc3ec7bc825c4e6ca746c659189cea83.jpg/v1/fill/w_1905,h_993,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/bc3ec7bc825c4e6ca746c659189cea83.jpg')",
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-[#FAF7F2]" />
      <div className="absolute inset-0 grain" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-24">
        <div className="max-w-3xl">
          <div className="rise-1 dot-divider text-[#F1EBE1]/90 mb-8">Cherry Stone — Singapore</div>

          <h1 className="rise-2 font-serif text-white text-[42px] sm:text-[58px] md:text-[76px] leading-[1.02] tracking-tight">
            Timeless stone,
            <br />
            <span className="italic text-[#F1EBE1]">crafted for life.</span>
          </h1>

          <p className="rise-3 mt-8 text-white/85 text-base md:text-lg max-w-xl leading-relaxed">
            Supply, in-house fabrication and installation of the world&rsquo;s finest marble,
            granite, quartz and sintered stone &mdash; for residential and commercial spaces across Singapore.
          </p>

          <div className="rise-4 mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#services"
              className="btn-cherry px-8 py-4 rounded-full text-xs tracking-[0.24em] uppercase font-medium"
            >
              Explore Our Craft
            </a>
            <a
              href="#projects"
              className="px-8 py-4 rounded-full text-xs tracking-[0.24em] uppercase font-medium border border-white/50 text-white hover:bg-white hover:text-[#1a1a1a] transition-all duration-300"
            >
              View Projects
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/70">
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ArrowDown size={16} className="animate-bounce" />
      </div>
    </section>
  );
};

export default Hero;
